import React from 'react';
import { FileIcon, ImageIcon } from 'lucide-react';
import PDFPreview from './PDFPreview';
import { UniqueImageFullScreen } from '../modal/UniqueImageFullScreen';

interface FileTypeIconProps {
  mimetype: string;
  publicUrl: string;
  width?: number;
  height?: number;
  className?: string;
  smallImageUrl?: string;
}

const FileTypeIcon: React.FC<FileTypeIconProps> = ({
  mimetype,
  publicUrl,
  smallImageUrl,
  width = 40,
  height = 40,
  className = ""
}) => {
  const imageExtensionList: string[] = [
    "jpg", "jpeg", "jpe", "ps", "eps", "ai", "pict", "pic", "pct",
    "png", "heic", "heif", "bmp", "dib", "gif", "jpx", "jpf", "psb",
    "iff", "ilbm", "jps", "mpo", "pcx", "crw", "cr2", "cr3", "pxr", "pbm",
    "pgm", "ppm", "pnm", "sct", "tga", "tpic", "webp", "avif",
  ];

  const tiffExtensionList: string[] = ["tiff", "tif"];

  const pdfExtensionList: string[] = ["pdf"];


  // Vérifier si c'est une image
  if (imageExtensionList.includes(mimetype)) {
    return (
      <div
        className={`w-[${width}px] h-[${height}px] flex justify-center items-center bg-gray-100 rounded-md overflow-hidden ${className}`}
        style={{ width: `${width}px`, height: `${height}px` }}
      >

        <UniqueImageFullScreen
          media={{
            url: smallImageUrl ?? "",
            largeUrl: publicUrl ?? smallImageUrl ?? "",
            alt: "",
            className: "w-full max-h-[250px] object-contain object-right",
          }}
        />
      </div>
    );
  }

  if (tiffExtensionList.includes(mimetype)) {
    return (
      <div className="w-[${width}px] h-[${height}px] flex justify-center items-center bg-gray-100 rounded-md overflow-hidden ${className}" style={{ width: `${width}px`, height: `${height}px` }}>
        <ImageIcon className="w-4 h-4 text-gray-500" />
      </div>
    );
  }

  // Vérifier si c'est un PDF
  if (pdfExtensionList.includes(mimetype)) {
    return (
      <PDFPreview
        fileUrl={publicUrl}
        width={width}
        height={height}
        className={className}
      />
    );
  }

  // Par défaut, afficher l'icône de fichier générique
  return (
    <div
      className={`w-[${width}px] h-[${height}px] flex justify-center items-center bg-gray-100 rounded-md ${className}`}
      style={{ width: `${width}px`, height: `${height}px` }}
    >
      <FileIcon className="w-4 h-4 text-gray-500" />
    </div>
  );
};

export default FileTypeIcon;
